import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ResetPasswordModule } from 'src/app/shared/modules/auth/reset-password/reset-password.module';
import { ResetPasswordComponent } from './reset-password.component';

@NgModule({
    imports: [CommonModule, ResetPasswordModule],
    declarations: [ResetPasswordComponent],
})
export class ResetPasswordBDPModule {}
